import { SCHEDULE_FILTER_COUNT_ZERO, SCHEDULE_FILTER_KEY } from './ScheduleFilterChips.constants';
import { messages } from './ScheduleFilterChips.messages';

function toScheduleFilterCount(count) {
  return count ?? SCHEDULE_FILTER_COUNT_ZERO;
}

export function isScheduleFilterRailEmpty(counts = {}) {
  const activeClasses = toScheduleFilterCount(counts.activeClasses);
  const disabledClasses = toScheduleFilterCount(counts.disabledClasses);

  return activeClasses === SCHEDULE_FILTER_COUNT_ZERO && disabledClasses === SCHEDULE_FILTER_COUNT_ZERO;
}

export function getDefaultScheduleFilterKey(counts = {}, isManualStudio = false) {
  if (isScheduleFilterRailEmpty(counts)) {
    return null;
  }

  const activeClasses = toScheduleFilterCount(counts.activeClasses);
  const disabledClasses = toScheduleFilterCount(counts.disabledClasses);

  if (!isManualStudio && activeClasses === SCHEDULE_FILTER_COUNT_ZERO && disabledClasses > SCHEDULE_FILTER_COUNT_ZERO) {
    return SCHEDULE_FILTER_KEY.DISABLED_CLASSES;
  }

  return SCHEDULE_FILTER_KEY.ACTIVE_CLASSES;
}

const MESSAGE_BY_FILTER_KEY = {
  [SCHEDULE_FILTER_KEY.ACTIVE_CLASSES]: messages.activeClasses,
  [SCHEDULE_FILTER_KEY.DISABLED_CLASSES]: messages.disabledClasses,
  [SCHEDULE_FILTER_KEY.WITH_CLIENTS_WAITING]: messages.withClientsWaiting,
  [SCHEDULE_FILTER_KEY.WITH_NEW_CLIENTS]: messages.withNewClients,
  [SCHEDULE_FILTER_KEY.WITH_RESERVATIONS]: messages.withReservations,
};

function buildOption({ key, count, disabled = false }) {
  return { key, count, disabled };
}

function buildZeroDisabledOption({ key, count }) {
  return buildOption({
    key,
    count,
    disabled: count === SCHEDULE_FILTER_COUNT_ZERO,
  });
}

function getScheduleFilterOptions({
  counts = {},
  hasSpotManagePermission = true,
  isManualStudio = false,
  showNewClients = false,
}) {
  if (isScheduleFilterRailEmpty(counts)) {
    return [];
  }

  const activeClasses = toScheduleFilterCount(counts.activeClasses);
  const withReservations = toScheduleFilterCount(counts.withReservations);
  const withNewClients = toScheduleFilterCount(counts.withNewClients);
  const withClientsWaiting = toScheduleFilterCount(counts.withClientsWaiting);
  const disabledClasses = toScheduleFilterCount(counts.disabledClasses);

  const options = [
    buildZeroDisabledOption({
      key: SCHEDULE_FILTER_KEY.ACTIVE_CLASSES,
      count: activeClasses,
    }),
    buildZeroDisabledOption({
      key: SCHEDULE_FILTER_KEY.WITH_RESERVATIONS,
      count: withReservations,
    }),
  ];

  if (showNewClients && withNewClients > SCHEDULE_FILTER_COUNT_ZERO) {
    options.push(
      buildOption({
        key: SCHEDULE_FILTER_KEY.WITH_NEW_CLIENTS,
        count: withNewClients,
      })
    );
  }

  if (hasSpotManagePermission && withClientsWaiting > SCHEDULE_FILTER_COUNT_ZERO) {
    options.push(
      buildOption({
        key: SCHEDULE_FILTER_KEY.WITH_CLIENTS_WAITING,
        count: withClientsWaiting,
      })
    );
  }

  if (!isManualStudio && disabledClasses > SCHEDULE_FILTER_COUNT_ZERO) {
    options.push(
      buildOption({
        key: SCHEDULE_FILTER_KEY.DISABLED_CLASSES,
        count: disabledClasses,
      })
    );
  }

  return options;
}

export function getVisibleScheduleFilterOptions({ formatMessage, ...params }) {
  return getScheduleFilterOptions(params).map(option => ({
    ...option,
    label: formatMessage(MESSAGE_BY_FILTER_KEY[option.key]),
  }));
}

export function isScheduleFilterKeySelectable(key, params) {
  return getScheduleFilterOptions(params).some(option => option.key === key && !option.disabled);
}
